import React, { useState } from "react";
import { Link } from "react-router-dom";

import { Alert } from "../components/Alert";
import { authApi } from "../services/authService";

interface Message {
  text: string;
  type: 'error' | 'success';
}

export const ResendActivation: React.FC = () => {
    const [email, setEmail] = useState<string>('');
    const [message, setMessage] = useState<Message>({ text: '', type: 'error' });
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
        e.preventDefault();
        setIsLoading(true);
        setMessage({ text: '', type: 'error' });
        const result = await authApi('/auth/resend-activation', {
            method: 'POST',
            body: JSON.stringify({ email }),
        });
        if (result.success) {
            setMessage({ text: result.message, type: 'success' });
            setEmail('');
        } else {
            setMessage({ text: result.error!, type: 'error' });
        }
        setIsLoading(false);
    };

    return (
        <div className="reg-layout">
            <div className="lcont">
                <h1 className="text-2xl font-bold text-center">Resend Activation Email</h1>
                {message.text && (
                    <Alert type={message.type} message={message.text} />
                )}
                <form onSubmit={handleSubmit} className="space-y-4" noValidate>
                    <fieldset className="fieldset">
                      <legend className="fieldset-legend">Email</legend>
                      <input
                          type="email"
                          placeholder="you@researchcentre.org"
                          className="w-full input input-bordered"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          aria-describedby="email-help"
                          autoComplete="email"
                        />
                        <p className="label">Enter the email address you used to register</p>
                    </fieldset>
                    <button type="submit" className="w-full btn btn-primary" disabled={isLoading}>
                        {isLoading ? <span className="loading loading-spinner"></span> : 'Resend Activation Email'}
                    </button>
                </form>
                <div className="text-sm text-center space-y-2">
                  <p>Already activated? <Link to="/login" className="text-primary hover:underline">Login</Link></p>
                  <div className="divider text-xs">OR</div>
                  <p>Need to register? <Link to="/register" className="text-primary hover:underline">Register</Link></p>
                </div>
            </div>
        </div>
    );
};
